"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseToHtml = parseToHtml;
const parse_js_1 = require("./parse.js");
const toDisplay_js_1 = require("./util/toDisplay.js");
const toHtml_js_1 = require("./util/toHtml.js");
/**
 * Parse a molecular formula and converts it to an HTML code
 * @param {String} mf String containing the molecular formula
 */
function parseToHtml(mf) {
    let parsed = (0, parse_js_1.parse)(mf);
    let display = (0, toDisplay_js_1.toDisplay)(parsed);
    return (0, toHtml_js_1.toHtml)(display);
}
//# sourceMappingURL=parseToHtml.js.map